import { Injectable } from '@angular/core';

type RequestIdentityPart = string | number | boolean | null;

@Injectable({ providedIn: 'root' })
export class ExclusiveRequestCoordinator {
    private readonly pending = new Map<string, Promise<unknown>>();

    run<T>(scope: string, identity: readonly RequestIdentityPart[], request: () => Promise<T>): Promise<T> {
        const key = JSON.stringify([scope, ...identity]);
        const pendingRequest = this.pending.get(key);
        // A scope/identity pair represents one operation and therefore one result type.
        if (pendingRequest) return pendingRequest as Promise<T>;

        const requestPromise = request().finally(() => {
            if (this.pending.get(key) === requestPromise) this.pending.delete(key);
        });
        this.pending.set(key, requestPromise);

        return requestPromise;
    }
}
